import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../../utils/api';

const ProtectedSuperAdminRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = checking, true = authenticated, false = not authenticated
  
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      const userType = localStorage.getItem('userType');
      
      if (!token || userType !== 'super_admin') {
        setIsAuthenticated(false);
        return;
      }
      
      // Verify token with backend
      try {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        await axios.get(`${API}/super-admin/me`);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Super Admin authentication failed:', error);
        localStorage.clear();
        setIsAuthenticated(false);
      }
    };
    
    checkAuth();
  }, []);
  
  // Show loading while checking authentication
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
          <p className="mt-2 text-gray-600">Verifying super admin access...</p>
        </div>
      </div>
    );
  }
  
  // Redirect to super admin login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/super-admin/login" replace />;
  }
  
  return children;
};

export default ProtectedSuperAdminRoute;
